<script setup lang="ts">
import { useRoute } from "vue-router";
import { computed } from "vue";
const { isDesktop, isMobile } = useDevice();
const route = useRoute();

function formatName(name: string): string {
  name = name.replace(/\b(ai)\b/g, "AI");
  name = name.replace(/\b(rag)\b/gi, "RAG");
  name = name.replace(/\b(nlp)\b/gi, "NLP");

  const lowerName = name.toLowerCase();

  switch (true) {
    case lowerName.includes("angularjs"):
      return name.replace(/angularjs/i, "Angular");
    case lowerName.includes("reactjs"):
      return name.replace(/reactjs/i, "React");
    case lowerName.includes("nodejs"):
      return name.replace(/nodejs/i, "Node");
    case lowerName.includes("vuejs"):
      return name.replace(/vuejs/i, "Vue");
    case lowerName.includes("keystonejs"):
      return name.replace(/keystonejs/i, "Keystone");
    case lowerName.includes("adonisjs"):
      return name.replace(/adonisjs/i, "Adonis");
    case lowerName.includes("sails"):
      return name.replace(/sails/i, "Sails");
    case lowerName.includes("backbonejs"):
      return name.replace(/backbonejs/i, "Backbone");
    case lowerName.includes("nuxtjs"):
      return name.replace(/nuxtjs/i, "Nuxt");
    case lowerName.includes("emberjs"):
      return name.replace(/emberjs/i, "Ember");
    case lowerName.includes("mlops"):
      return name.replace(/\b(mlops)\b/gi, "MLOps");
    default:
      return name;
  }
}

const breadCrumbRoutes = computed(() => {
  const segments = route.path.split("/").filter(Boolean);

  const crumbs = segments.map((segment, index) => {
    let name = decodeURIComponent(segment.replace(/-/g, " "));
    name = formatName(name);

    return {
      name,
      to: "/" + segments.slice(0, index + 1).join("/"),
    };
  });

  const allCrumbs = [{ name: "Home", to: "/" }, ...crumbs];

  if (isMobile) {
    const home = allCrumbs[0];
    const current = allCrumbs[allCrumbs.length - 1];
    if (current !== home) return [home, current];
    return [home];
  }

  return allCrumbs;
});
</script>

<template>
  <nav
    class="max-w-screen-xl px-4 mx-auto flex items-center gap-1 text-sm tracking-[0.5px] z-30"
  >
    <template v-for="(crumb, index) in breadCrumbRoutes" :key="crumb.to">
      <NuxtLink
        v-if="index !== breadCrumbRoutes.length - 1"
        :to="crumb.to"
        class="capitalize hover:underline text-base font-semibold first:shrink-0"
        :class="{
          'text-sm line-clamp-1': isMobile,
        }"
      >
        {{ crumb.name }}
      </NuxtLink>
      <span
        v-else
        class="capitalize text-base font-bold cursor-default first:shrink-0"
        :class="{
          'text-sm line-clamp-1': isMobile,
        }"
        aria-current="page"
      >
        {{ crumb.name }}
      </span>
      <span v-if="index !== breadCrumbRoutes.length - 1" class="mx-1 text-base"
        >›</span
      >
    </template>
  </nav>
</template>
